import { AnnualReward, Message } from '@app/core/interfaces';
import { type } from '@app/store/util';
import { Action } from '@ngrx/store';

export const LOAD = type('[annual] load');
export const LOAD_SUCCESS = type('[annual] load success');
export const LOAD_ERROR = type('[annual] load error');
export const SELECT = type('[annual] select');

export class LoadAnnualReward implements Action {
    readonly type = LOAD;
}

export class LoadAnnualRewardSuccess implements Action {
    readonly type = LOAD_SUCCESS;
    constructor(public payload: { annualReward: AnnualReward }) {}
}

export class LoadAnnualRewardError implements Action {
    readonly type = LOAD_ERROR;
    constructor(public payload: { errors: Message[] }) {}
}

export type Actions
    = LoadAnnualReward
    | LoadAnnualRewardSuccess
    | LoadAnnualRewardError;
